import companies from "./companies.json";
import software from "./software.json";
import components from "./components.json";
import taxonomy from "./taxonomy.json";
import { slugifyDirectoryValue } from "../../utils/directoryUtils";

export { companies, software, components, taxonomy };

export const companiesBySlug = Object.fromEntries(companies.map((item) => [item.slug, item]));
export const softwareBySlug = Object.fromEntries(software.map((item) => [item.slug, item]));
export const componentsBySlug = Object.fromEntries(components.map((item) => [item.slug, item]));

export const continentBySlug = Object.fromEntries(
  taxonomy.continents.map((continent) => [slugifyDirectoryValue(continent), continent]),
);

export const softwareCategoryBySlug = Object.fromEntries(
  Object.entries(taxonomy.softwareCategories).map(([slug, value]) => [slug, {
    slug,
    name: value[0],
    title: value[1],
    description: value[2],
  }]),
);

export const componentCategoryBySlug = Object.fromEntries(
  Object.entries(taxonomy.componentCategories).map(([slug, value]) => [slug, {
    slug,
    name: value[0],
    title: value[1],
    description: value[2],
  }]),
);

export function companyPath(company) {
  return `/robotics-companies/${company.slug}`;
}

export function softwarePath(item) {
  return `/robotics-software/${item.slug}`;
}

export function componentPath(item) {
  return `/robot-components/${item.slug}`;
}
